
































import { Vue,Component } from 'vue-property-decorator'
import { State,Action,namespace } from 'vuex-class'
import PagedTable from '../../components/common/pagedTable.vue'
import Partner from '../../components/partner.vue'
import exicon from '../../assets/js/expressicon'
const financial = namespace('financial')
const common = namespace('common')
@Component({
    components: {
        PagedTable,
        Partner
    }
})
export default class PartnerRechangeList extends Vue{
    @financial.State('partnerRechangePager') partnerRechangePager:any
    @financial.State('partnerRechangeList') partnerRechangeList:any
    @financial.State('loading') loading:any
    exicon:any = exicon
    time:any = []
    site:string = '' //网点id
    partner:string = '' //快递员id
    multipleSelection:any = [] //勾选的项
    get search() {
        let start = ''
        let end = ''
        if(this.time){
            start = this.time[0]
            end = this.time[1]
        }
        return {
            site: this.site,
            link: this.partner,
            start: start,
            end: end,
            pageSize: 20,
            page: 1
        }
    }
    get tablecolumn(){
        return [
            {
                prop: 'site',
                type: 'nextProp',
                nextProp: 'name',
                label: '网点',
            },
            {
                prop: 'oprator',
                type: 'nextProp',
                nextProp: 'name',
                label: '操作人',
            },
            {
                prop: 'name',
                name: 'name',
                type: 'slot',
                label: '快递员姓名',
            },
            {
                prop: 'amount',
                type: 'text',
                label: '充值金额',

            },
            {
                prop: 'present',
                type: 'text',
                label: '赠送金额',

            },
            {
                prop: 'total',
                type: 'text',
                label: '合计',

            },
            {
                prop: 'ctime',
                type: 'text',
                label: '充值时间',
            }
        ]
    }
    @financial.Action('getPartnerRechangeList') getPartnerRechangeList:any
    created(){
        this.getList()
    }
    getList(){
        this.getPartnerRechangeList(this.search)
    }
    // 网点改变的时候
    changeSite(val:string){
        this.site = val
        this.getList()
    }
    // 翻页
    pagechange(e:any){
        this.search.page = e[0].val
        this.getList()
    }
    // 页数
    pageSizechange(e:any){
        this.search.pageSize = e[0].val
        this.getList()
    }
    // 导出数据
    async exportexcel(){
        if(this.time.length < 1){
            this.$message({ message: '时间段必须选择', type: 'warning' });
            return
        }
        const token = window.localStorage.getItem('token');
        window.open(`${process.env.VUE_APP_API}/admin/capitalflow/exportToExcel?start=${this.time[0]}&end=${this.time[1]}&site=${this.site}&link=${this.search.link}&token=${token}`); 
    }
}
